export const formatCampaignTitle = (campaignObj) => {
  let syntheticId = campaignObj?.parent_id ? campaignObj.synthetic_id : null;
  let campaignName = campaignObj?.campaign_display_name || campaignObj?.campaign_name || campaignObj?.campaignName;
  if (!campaignName) return '';
  if (!syntheticId || syntheticId === '-') return campaignName;
  return `${campaignName}:|${syntheticId}`;
};

export const numberToCurrencyString = (number) => {
  let num = number;
  if (typeof number === 'string') {
    num = Number(number);
    if (isNaN(num)) {
      return '';
    }
  }
  if (typeof num === 'number') {
    return num.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  return '';
};

export const isValidNumber = (value) => !isNaN(value);

export const getLocalCurrency = (currencyName, budget) => {
  if (currencyName === 'USD') {
    return budget?.toLocaleString('en-US', {style: "currency", currency: "USD"});
  } else {
    return budget?.toLocaleString('en-US', {style: "currency", currency: currencyName});
  }
};

export const formatNumberToUSDCurrency = (number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(number);
};
